import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import PropTypes from "prop-types";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const GoalReportTeamsChart = ({ title, subtitle, labels, dataValues }) => {
  const data = {
    labels,
    datasets: [
      {
        label: "Achievement",
        data: dataValues,
        backgroundColor: "#FFB5A7",
        borderRadius: 8,
        barThickness: 36,
        maxBarThickness: 55,
        categoryPercentage: 1.0,
        barPercentage: 0.5
      },
    ],
  };

  const options = {
    indexAxis: "y",
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: {
        callbacks: {
          label: ctx => `${ctx.raw}%`,
        },
      },
    },
    scales: {
      x: {
        beginAtZero: true,
        max: 100,
        ticks: {
          callback: val => `${val}%`,
        },
        grid: {
          drawBorder: false,
          color: "#eee",
        },
      },
      y: {
        grid: {
          drawBorder: false,
          color: "#f3f3f3",
        },
        ticks: {
          font: { size: 14 },
        },
      },
    },
  };

  return (
    <div
      style={{
        border: "1px solid #eee",
        borderRadius: "10px",
        padding: "20px",
        width: "100%",
        backgroundColor: "#fff",
      }}
    >
      <h3 style={{ margin: 0, fontSize: "16px", fontWeight: "600", color: "#333" }}>
        {title}
      </h3>
      <p style={{ margin: "4px 0 20px", fontSize: "13px", color: "#777" }}>{subtitle}</p>
      <div style={{ height: `${labels.length * 60}px` }}>
        <Bar data={data} options={options} />
      </div>
    </div>
  );
};

export default GoalReportTeamsChart;
